enum KioskAuthenticationMode {
  'PIN' = 0,
  'FACE_UNLOCK' = 3,
}

export default KioskAuthenticationMode;
